import { Col, FormGroup, Input, Label } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { SelectPaymentMethod } from "../../../../Constant";

export const CardTypeDetail = () => {
  const paymentModeName = ["Visa", "MasterCard", "paypal"];

  return (
    <Col xxl="6" className="mb-3">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{SelectPaymentMethod}</H6>
        <div className="radio-form">
          {paymentModeName.map((data, index) => (
            <FormGroup check key={index} className="mb-3">
              <Input id={`flexRadioDefault${index}`} type="radio" name="paymentMethod" value="visa" />
              <Label className="form-check-label" htmlFor={`flexRadioDefault${index}`} check>
                {data}
              </Label>
            </FormGroup>
          ))}
        </div>
      </div>
    </Col>
  );
};
